import { isSameDay } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { Text } from 'ui';

const DurationOptionLabel = ({ end, mainLabel, start }: { end?: Date; mainLabel: string; start?: Date }) => {
  const { t } = useTranslation();

  if (!start || !end || isSameDay(start, end)) {
    return <Text>{mainLabel}</Text>;
  }

  return (
    <div>
      <Text>{mainLabel}</Text>
      <div>
        <Text size="small" type="secondary">
          {t('Ends on')} {t('dateFormats.shortMonthDayYear', { date: end })}
        </Text>
      </div>
    </div>
  );
};

export default DurationOptionLabel;
